import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("b", null, "Details", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("b", null, "Cast", -1)
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "view-movie__person--missing"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("b", null, "Posters", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Image = _resolveComponent("Image")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Divider, {
      align: "left",
      class: "view-movie__divider"
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createVNode(_component_Card, null, {
      title: _withCtx(() => [
        _createTextVNode(" Release Date: " + _toDisplayString(_ctx.movieView?.release?.toDateString()), 1)
      ]),
      subtitle: _withCtx(() => [
        _createElementVNode("div", null, " Runtime: " + _toDisplayString(_ctx.movieView?.runtime), 1),
        _createElementVNode("div", null, " Director: " + _toDisplayString(_ctx.movieView?.director), 1),
        _createElementVNode("div", null, " Revenue: " + _toDisplayString(_ctx.movieView?.earning), 1)
      ]),
      content: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.movieView?.description), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_Divider, {
      align: "left",
      class: "view-movie__divider"
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.movieView?.people, (person, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "col-fixed",
        key: index
      }, [
        _createVNode(_component_Card, { class: "view-movie__person" }, {
          header: _withCtx(() => [
            (person.profile)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: person.profile,
                  alt: "No image found"
                }, null, 8, _hoisted_3))
              : (_openBlock(), _createElementBlock("div", _hoisted_4))
          ]),
          title: _withCtx(() => [
            _createTextVNode(_toDisplayString(person.name), 1)
          ]),
          subtitle: _withCtx(() => [
            _createTextVNode(_toDisplayString(person.job), 1)
          ]),
          _: 2
        }, 1024)
      ]))
    }), 128)),
    _createVNode(_component_Divider, {
      align: "left",
      class: "view-movie__divider"
    }, {
      default: _withCtx(() => [
        _hoisted_5
      ]),
      _: 1
    }),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.movieView?.posters, (picture, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "col-fixed",
        key: index
      }, [
        _createVNode(_component_Card, { class: "view-movie__poster" }, {
          header: _withCtx(() => [
            _createVNode(_component_Image, {
              src: picture.poster,
              preview: ""
            }, null, 8, ["src"])
          ]),
          title: _withCtx(() => [
            _createTextVNode(" Rating: " + _toDisplayString(picture.rating), 1)
          ]),
          subtitle: _withCtx(() => [
            _createTextVNode(" Language: " + _toDisplayString(picture.language), 1)
          ]),
          _: 2
        }, 1024)
      ]))
    }), 128))
  ], 64))
}